import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getPostData,
    getPostDataCancelToken,
    resetPublicView } from '../../../actions/publicView/view';
import { decodeString, isYoutubeVideo, formatDate } from '../../../utils/helper';
import LoggedoutUserBar from '../../../components/bars/LoggedoutUserBar';
import YoutubeEmbed from '../../loggedIn/Feed/common/YoutubeEmbed';
import DownloadIcon from '../../../assets/images/collaborations/view/download-2.svg';
import LoggedoutMetaBar from '../../../components/bars/LoggedOutMetaBar';
import LoginForm from '../Login/LoginForm';
import linkifyHtml from 'linkifyjs/html';

import Loader from '../../../components/misc/Loader';
import { miscLinks } from '../../../utils/internalLinks';
import UserName from '../../../components/profile/UserName';
import SeoHeadMeta from '../../../components/misc/SeoHeadMeta';
import ReadMoreLinkified from '../../loggedIn/Feed/common/ReadMoreLinkified';

function ProductReviewView(props) {
    const [collaborationData, setCollaborationData] = useState(null),
        [showLoginForm, setShowLoginForm] = useState(false);
    useEffect(() => {
        props.getPostData('collaborate', props.match.params.id)
        .then(val => {
            //redirect to 404 if invalid
            if(!val) {
                props.history.replace(miscLinks.notFound);
            }
        });
        return function cleanup() {
            if (getPostDataCancelToken) getPostDataCancelToken();
            props.resetPublicView();
        }
    }, [props.match.params.id]);
    useEffect(() => {
        setCollaborationData(props.publicView.viewData);
    }, [props.publicView.viewData]);
    const collaborate = collaborationData
            && collaborationData.collaborate
            ? collaborationData.collaborate
            : null,
        isCompany = collaborate
        && collaborationData
        && collaborate.company_id,
        name = collaborate
        && collaborationData
        ? isCompany
            ? decodeString(collaborate.owner.name)
            : decodeString(collaborate.profile.name)
            : '',
        imageToShow = collaborate
            && collaborationData
            ? isCompany
            ? collaborate.owner.logo_meta
                ? JSON.parse(collaborate.owner.logo_meta).original_photo
                : ''
            : collaborate.profile.image_meta
                ? JSON.parse(collaborate.profile.image_meta).original_photo
                :  ''
            : '',
        youtubeId = collaborate
            && collaborate.video
            ? isYoutubeVideo(collaborate.video)
            : null,
        addresses = collaborate
            && collaborate.addresses
            && collaborate.addresses.length
            ? collaborate.addresses.map(address => address.city).join(', ').replace(/,(?!.*,)/gmi, ' and')
            : null,
        createdAt = collaborate
            && collaborate && collaborate.created_at
            ? formatDate.post(collaborate.created_at)
            : null;
    return (<div className="container">
        { collaborationData
            && collaborationData.seoTags
            && collaborationData.seoTags.title
            && <SeoHeadMeta title={collaborationData.seoTags.title}>
                <title>{decodeString(collaborationData.seoTags.title)}</title>
            </SeoHeadMeta>}
        <div className="collaboration__view collaboration__view--with-height">
            <div className="collaboration__view__details">
                {
                    props.publicView.fetching
                    ? <Loader isCentered={true} withMargin={true} />
                    : props.publicView.viewData
                    && props.publicView.viewData.collaborate
                    && collaborate
                    ? (<>
                        <div className="collaboration__view__details__container">
                            <p className="collaboration__view__details__heading">Product Review</p>
                            <ReadMoreLinkified className="collaboration__view__details__name"
                                hashtagEventLabel="Collaboration"
                                text={collaborate.title} />
                            {   (!!collaborate.type
                                || !!collaborate.categories)
                                && <p className="collaboration__view__details__types">
                                { !!collaborate.type  && <span>{collaborate.type.name}</span> }
                                { !!collaborate.type  && !!collaborate.categories && <span className="collaboration__view__details__types__divider">&bull;</span> }
                                { !!collaborate.categories && <span>{collaborate.categories.name}</span> }
                            </p>
                            }
                            <div className="collaboration__view__details__posted">
                                <LoggedoutUserBar image={imageToShow}
                                    isCompany={isCompany}
                                    createdAt={createdAt}
                                    publicClickAction={() => setShowLoginForm(true)}
                                    name={name} />
                                <button onClick={() => setShowLoginForm(true)}
                                    className="collaboration__view__action__btn collaboration__view__action__btn--yellow">
                                    SHOW INTEREST
                                </button>
                            </div>
                            {
                                collaborate.images_meta
                                && !!collaborate.images_meta.length
                                &&  <div className="collaboration__view__details__images">
                                        {
                                            collaborate.images_meta.map((image, key) => {
                                                return <img src={image.original_photo}
                                                    key={key}
                                                    onClick={() => setShowLoginForm(true)}
                                                    className="collaboration__view__details__image cursor-pointer"
                                                    alt={`collaboration ${key + 1}`}/>
                                            })
                                        }
                                </div>
                            }
                            {
                                collaborate.video
                                && youtubeId
                                && <div className="collaboration__view__details__video-container"><YoutubeEmbed youtubeId={youtubeId} /></div>
                            }
                            {
                                collaborate.file1
                                &&  (<div onClick={() => setShowLoginForm(true)} className="collaboration__view__details__downloads">
                                    <p className="cursor-pointer collaboration__view__details__downloads__link">
                                        <img src={DownloadIcon} className="collaboration__view__details__downloads__icon" alt="download icon"/>
                                        <span className="collaboration__view__details__downloads__text">Download Document</span>
                                    </p>
                                </div>)
                            }
                            <div className="collaboration__view__details__information__container">
                                {
                                    collaborate
                                    && (collaborate.brand_name || collaborate.brand_logo)
                                    && (<div className="collaboration__view__details__information">
                                        <p className="collaboration__view__details__information__heading">Brand</p>
                                        <div className="collaboration__view__details__information__details">
                                            {
                                                collaborate.brand_logo
                                                && <img className="collaboration__view__details__information__icon"
                                                    src={collaborate.brand_logo} alt={collaborate.brand_name} />
                                            }
                                            <p className="collaboration__view__details__information__text">{decodeString(collaborate.brand_name)}</p>
                                        </div>
                                    </div>)
                                }
                                {
                                    collaborate
                                    && collaborate.tasting_methodology
                                    && (<div className="collaboration__view__details__information">
                                        <p className="collaboration__view__details__information__heading">Tasting Method</p>
                                        <div className="collaboration__view__details__information__details">
                                            <p className="collaboration__view__details__information__text">{collaborate.tasting_methodology.name}</p>
                                        </div>
                                    </div>)
                            }
                            </div>
                            {
                                collaborate
                                && collaborate.collaborate_allergens
                                && !!collaborate.collaborate_allergens.length
                                && <div className="collaboration__view__details__information__container">
                                        <div className="collaboration__view__details__information">
                                            <p className="collaboration__view__details__information__heading">Allergens</p>
                                            <div className="collaboration__view__details__information__details">
                                                { collaborate.collaborate_allergens.map((allergen, index) => {
                                                    return <div key={`allergens-${index}`} className="collaboration__view__details__information__text
                                                        collaboration__view__details__information__text--multi">
                                                            {
                                                                allergen.image
                                                                && <img className="collaboration__view__details__information__icon--multi"
                                                                    src={allergen.image} alt={allergen.name} />
                                                            }
                                                            {allergen.name}
                                                        </div>
                                                })}
                                            </div>
                                        </div>
                                </div>
                            }
                            {
                                collaborate.description
                                && <ReadMoreLinkified className="collaboration__view__details__description"
                                    isOpen={true}
                                    isPublic={true}
                                    hashtagEventLabel="Collaboration"
                                    publicClickAction={() => setShowLoginForm(true)}
                                    text={collaborate.description} />
                            }
                            {
                                collaborate.financials
                                && <div className="collaboration__view__details__information__container">
                                    <div className="collaboration__view__details__information">
                                        <p className="collaboration__view__details__information__heading">Financial</p>
                                        <p className="collaboration__view__details__information__text collaboration__view__details__information__text--top-margin">
                                            { decodeString(collaborate.financials) }
                                        </p>
                                    </div>
                                </div>
                            }
                            {
                                (addresses || !!collaborate.is_taster_residence)
                                && <div className="collaboration__view__details__information__container">
                                    <div className="collaboration__view__details__information">
                                        <p className="collaboration__view__details__information__heading">Locations</p>
                                        <ul className="collaboration__view__details__list">
                                            { addresses && <li className="collaboration__view__details__list__item">&bull; {addresses}</li> }
                                            { !!collaborate.is_taster_residence && <li className="collaboration__view__details__list__item">&bull; Home User Tasting (HUT) available</li> }
                                        </ul>
                                    </div>
                                </div>
                            }
                            {
                                isCompany
                                && collaborate.profile
                                && <p className="collaboration__view__details__creator cursor-pointer" onClick={() => setShowLoginForm(true)}>Posted by <UserName name={collaborate.profile.name} isVerified={!!collaborate.profile.verified} /></p>
                            }
                        </div>
                        {
                            collaborationData
                            && collaborationData.meta
                            && <LoggedoutMetaBar meta={collaborationData.meta}
                                publicClickAction={() => setShowLoginForm(true)} />
                        }
                    </>)
                    : null
                }
            </div>
        </div>
        { showLoginForm && <LoginForm shouldOnlyToggle={true}
            toggleLoginForm={() => setShowLoginForm(false)} /> }
    </div>)
};

function mapStateToProps(state) {
    return {
        publicView: state.publicView
    }
}

const mapDispatchToProps = {
    getPostData,
    resetPublicView
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductReviewView);